import React from 'react';
import { connect } from 'react-redux';
import { FreeLayout } from 'Layouts';

import './GiftCardRedeemConfirmation.css';

export function GiftCardRedeemConfirmation({ giftCardRedeemConfirmation }) {
  return <FreeLayout className="giftCardRedeemConfirmationPage" screenName={giftCardRedeemConfirmation} />;
}

const mapStateToProps = ({ appConfig: { screens } = {} }) => ({
  giftCardRedeemConfirmation: screens.giftCardRedeemConfirmation,
});

export const GiftCardRedeemConfirmationContainer = connect(mapStateToProps)(GiftCardRedeemConfirmation);
